import { EventHelper, Popup } from "@bryntum/schedulerpro";

/**
 * This popup is used by the "Push event" menu
 */
export default class EventPushByMenu extends Popup {
  static $name = "EventPushByMenu";

  static configurable = {
    header: "Push events by",
    autoShow: false,
    centered: true,
    closable: true,
    modal: true,
    closeAction: "destroy",
    width: "20em",
    minHeight: "18em",
    bbar: {
      items: {
        cancel: {
          text: "Cancel",
          minWidth: 100,
          onAction: "up.close"
        },
        close: {
          text: "OK",
          minWidth: 100,
          cls: "b-raised b-blue",
          onAction: "up.saveAndClose"
        }
      }
    },
    items: {
      unitField: {
        type: "combo",
        label: "Unit",
        labelWidth: "5em",
        name: "unit",
        value: "day",
        items: [
          ["minute", "Minute"],
          ["hour", "Hour"],
          ["day", "Day"],
          ["week", "Week"],
          ["month", "Month"]
        ]
      },
      amountField: {
        type: "number",
        label: "Amount",
        labelWidth: "5em",
        name: "amount",
        value: 1
      }
    },
    listeners: {
        paint() {
            EventHelper.on({
                element: this.element,
                keyup: (event) => {
                    if (event.code === "Enter") {
                        this.saveAndClose();
                    }
                }
            });
        }
    }
  };

  saveAndClose() {
    const { values } = this;
    this.trigger("save", { ...values });
    console.log(values);
    this.close();
  }
}

EventPushByMenu.initClass();
